import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'
import * as React from 'react'
import {Component, lazy, Suspense} from 'react'
import RaisedButton from './RaisedButton'
import StyledError from './StyledError'

const HiddenInput = styled('input')({
  display: 'none'
})

const Control = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  overflow: 'hidden',
  padding: '.5rem 1rem 1rem',
  position: 'relative'
})






const Confetti = lazy(() => import(/* webpackChunkName: 'Confetti' */ './Confetti'))

class AvatarInput extends Component {constructor(...args) { super(...args); AvatarInput.prototype.__init.call(this);AvatarInput.prototype.__init2.call(this);AvatarInput.prototype.__init3.call(this); }
  __init() {this.inputRef = React.createRef()}
  __init2() {this.onClick = () => {
    if (this.inputRef.current) {
      this.inputRef.current.click()
    }
  }}
  __init3() {this.onChange = (e) => {
    const {onSubmit} = this.props
    const {files} = e.currentTarget
    const imageToUpload = files ? files[0] : null
    if (!imageToUpload) return
    onSubmit(imageToUpload)
  }}

  render() {
    const {error} = this.props
    const isHack = error === 'xss'
    const errorStr = isHack ? 'You hacked us!' : error
    return (
      _jsxs('div', { children: [
        _jsxs(Control, { children: [
          _jsx(RaisedButton, { size: "small", onClick: this.onClick, palette: "gray", type: "button", children: 
            'Choose File'
          })
          , _jsx('form', { onSubmit: this.onChange, children: 
            _jsx(HiddenInput, {
              accept: "image/*",
              onChange: this.onChange,
              type: "file",
              ref: this.inputRef,}
            )
          })
        ]})
        , _jsx(Suspense, { fallback: '', children: 
          _jsx(Confetti, { active: isHack,} )
        })
        , error && _jsx(StyledError, { children: errorStr})
      ]})
    )
  }
}

export default AvatarInput
